import 'rxjs/add/operator/toPromise';
import { Storage } from '@ionic/storage';

import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { Device } from '@ionic-native/device';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class User {
  _user: any;

  constructor(public api: Api, private storage: Storage, public device: Device) {
 
     
  }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    this.storage.set('token', null);
    let seq = this.api.post('oauth/v2/token', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.access_token !== '' && res.enabled == true) {
        this.storage.set('token', res.access_token);
        this.registerdevice();
        this._loggedIn(res);
      }
    }, err => {
      console.error('ERROR', err);
    });

    return seq;
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    let seq = this.api.post('signup', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status == 'success') {
        
        this._loggedIn(res); 
      }
    }, err => {
      console.error('ERROR', err);
    });

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this._user = false;
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this._user = resp;
  }

  /**
   * Is logged In
   */
  isLoggedIn() {
    let seq = this.api.post('checktoken', []).share();
     seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.error !== true) {
        return true;
      } else {
        return false;
      } 
    }, err => {
      return false;
    });
    return seq;
  }

  registerdevice() {
   return  this.storage.get('pushid')
      .then((pushid) => {
        if( pushid !==null) {
          const data = {
            name:       this.device.manufacturer || '',
            model:      this.device.model,
            platform:   this.device.platform,
            pushid:     pushid,
            uuid:       this.device.uuid
          };
          let seq = this.api.post('api/device', data).share();

          seq.subscribe((res: any) => {
            // If the API returned a successful response, mark the user as logged in
            if (res.status == 'success') {
              
              this._loggedIn(res); 
            }
          }, err => {
            console.error('ERROR', err);
          });
      
          return seq;
        }
    })
   }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts